/// <reference path="../pocmemberform.js" />
import React, { useEffect, useState } from 'react';
import { Alert, Col, Container, FormCheck, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import '../../../../styles/Forms.css';
import { ProviderSection } from './ProviderSection';
import { StaffSection } from './StaffSection';
import { POCSection } from './POCSection';
import { SaveSubmitButtons } from '../SaveSubmitButtons';
import { NameSection } from './NameSection';
import { DobEmailSection } from './DobEmailSection';
import { ServicesSection } from './ServicesSection';
import { HHIEButton } from '../../../utility/HHIEButton';

export function MemberForm() {
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [poc, setPoc] = useState(false);
    const [pocOkay, setPocOkay] = useState(false);
    const [provider, setProvider] = useState(false);
    const [providerOkay, setProviderOkay] = useState(false);
    const [staff, setStaff] = useState(false);
    const [staffOkay, setStaffOkay] = useState(false);
    const [basicReqsOkay, setBasicReqsOkay] = useState(false);
    const [specialtiesList, setSpecialtiesList] = useState(null);
    const [member, setMember] = useState(null);
    const [pocLength, setPocLength] = useState(0);
    const [pocMaxLength, setPocMaxLength] = useState(3);
    const [chr, setChr] = useState(false);
    const [chrAllowed, setChrAllowed] = useState(false);
    const [dsm, setDsm] = useState(false);
    const [dsmAllowed, setDsmAllowed] = useState(false);
    const [referrals, setReferrals] = useState(false);
    const [referralsAllowed, setReferralsAllowed] = useState(false);
    const [notify, setNotify] = useState(false);
    const [notifyAllowed, setNotifyAllowed] = useState(false);
    const [servicePOC, setServicePOC] = useState("");
    const [account, setAccount] = useState(null);
    const [submitFeature, setSubmitFeature] = useState(false);
    const [saving, setSaving] = useState(false);
    const [savingMessage, setSavingMessage] = useState(null);

    useEffect(() => {
        try {
            var acct = JSON.parse(sessionStorage.getItem("account"));
            setAccount(acct)
            var chr = false;
            var notify = false;
            if (acct.registrationType && acct.registrationType !== "") {
                var services = acct.registrationType.split(";");
                for (var service of services) {
                    if (service === "CHR") {
                        chr = true;
                        setChrAllowed(true);
                    }
                    else if (service === "Notify") {
                        notify = true;
                        setNotifyAllowed(true);
                    }
                    else if (service === "DSM") {
                        setDsmAllowed(true);
                    }
                    else if (service === "Referrals") {
                        setReferralsAllowed(true);
                    }
                      
                }
            }
            else {
                chr = acct.chr;
                setChrAllowed(acct.chr);
                notify = acct.notify;
                setNotifyAllowed(acct.notify);
                setDsmAllowed(acct.dsm);
                setReferralsAllowed(acct.referrals);
            }
            if (chr && notify) {
                setPocMaxLength(6);
            }

            
            var initialAcctPocs = acct.poCs;
            var acctPocs = [];
            initialAcctPocs.forEach((poc) => {
                var inList = false;
                acctPocs.forEach((acctPoc) => {
                    if (!poc.id || poc.id === "") {
                        inList = false;
                    }
                    else if (poc.id === acctPoc.id) {
                        inList = true;
                    }
                })
                if (!inList) {
                    acctPocs.push(poc);
                }
            })
            setPocLength(acctPocs.length);
            setUser(JSON.parse(sessionStorage.getItem("user")));
            setMember(JSON.parse(sessionStorage.getItem("member")));
            var currentMember = JSON.parse(sessionStorage.getItem("member"));
            setProvider(currentMember.passStatus.type && currentMember.passStatus.type === "Provider" && !(currentMember.npi === "" || currentMember.npi === null));
            setStaff(currentMember.passStatus.type && currentMember.passStatus.type.includes("Staff") && currentMember.jobTitle !== "null" && currentMember.jobTitle !== "");
            setChr(currentMember.chr);
            setDsm(currentMember.dsm);
            setReferrals(currentMember.referrals);
            setNotify(currentMember.notify);
            setPoc(currentMember.isPOC);
            setLoading(false);
        }
        catch (exception) {
            alert("Something went wrong. You will be redirected to the dashboard. From there, please select to either Add or Edit a Member");
            window.location.href = "/registration-dashboard";
        }

        fetch('api/admin/GetFeatures')
            .then((response) => {
                response.json()
                    .then((json) => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        for (var i = 0; i < json.message.length; i++) {
                            if (json.message[i].name === "singleMemberSubmit") {
                                setSubmitFeature(json.message[i].value);
                            }
                        }
                    })
                    .catch((error) => {
                        console.log("Retrieve json error: " + error);
                    })
            })
            .catch((error) => {
                console.log("Retrieve response error: " + error);
            })

        fetch('api/Registration/getSpecialties')
            .then((response) => {
                response.json()
                    .then((json) => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        setSpecialtiesList(json.message);
                    })
                    .catch((error) => {
                        console.log("json error: " + error);
                    })
            })
            .catch((error) => {
                console.log("Response error: " + error);
            });
    }, [])

    useEffect(() => {
        checkBasics()
    }, [member])

    const checkBasics = () => {
        if (member && (member.firstName && member.firstName !== "") && (member.hasNoMiddleName || (member.middleName && member.middleName !== "")) && (member.lastName && member.lastName !== "") && (member.email && member.email.includes("@"))) {
            setBasicReqsOkay(true);
        }
        else {
            setBasicReqsOkay(false);
        }
    }

    const appendData = () => {
        const formData = new FormData();
        formData.append("userId", user.sfid);
        formData.append("userMid", user.memberID);
        formData.append("userPOCId", user.pocid);
        formData.append("id", member.id);
        formData.append("mid", member.mid);
        formData.append("accountId", member.account.id);
        formData.append("accountName", member.account.legalName);
        formData.append("firstName", member.firstName);
        formData.append("middleName", member.middleName);
        formData.append("lastName", member.lastName);
        formData.append("isProvider", provider);
        formData.append("isStaff", staff);
        formData.append("isPOC", poc);
        formData.append("npi", provider?member.npi:"");
        formData.append("stateLicense", (provider||staff)?member.stateLicense:"");
        formData.append("abbrTitle", provider?member.abbrTitle:"");
        formData.append("specialty", provider?member.specialty:"");
        formData.append("jobTitle", staff?member.jobTitle:"");
        formData.append("pocType", member.pocTypeName);
        formData.append("dob", member.dob);
        formData.append("email", member.email);
        formData.append("createdDate", member.createdDate);
        formData.append("chr", chr);
        formData.append("dsm", dsm);
        formData.append("notify", notify);
        formData.append("referrals", referrals);
        formData.append("userType", user.isPOCUser ? "POCUser" : "HHIEUser");
        formData.append("username", user.isPOCUser ? user.userID : "");
        formData.append("servicePOC", servicePOC);
        formData.append("hasNoMiddleName", member.hasNoMiddleName);
        return formData;
    }


    const handleSave = (saveContinueNew) => {
        setSavingMessage(null);
        setSaving(true);
        const formData = appendData();
        const requestOptions = {
            method: 'POST',
            body: formData
        }
        fetch('api/registration/saveMember', requestOptions)
            .then((response) => {
                response.json()
                    .then((text) => {
                        if (text.errors !== null && text.errors !== "") alert(text.errors)
                        member.mid = text.message.split(":")[0];

                        if (member.id === user.sfid && user.memberID === 0) {
                            let tempUser = user;
                            setUser(tempUser);
                            tempUser.memberID = parseInt(text.message.split(":")[0]);
                            sessionStorage.setItem("user", JSON.stringify(tempUser));
                        }

                        setSavingMessage(text.message.split(":")[1]);
                        setSaving(false);
                        if (saveContinueNew === "leave") window.location.href = "/registration-dashboard"
                        else if (saveContinueNew === "new") {
                            let acct = account;
                            if (provider && chr) acct.chrProviderCount++;
                            if (!provider && chr) acct.chrStaffCount++;
                            if (provider && notify) acct.notifyProviderCount++;
                            if (!provider && notify) acct.notifyStaffCount++;
                            sessionStorage.setItem("account", JSON.stringify(acct));

                            fetch('api/registration/GetNewMemberForAccount/' + account.id + '/' + account.legalName)
                                .then((response) => {
                                    response.json()
                                        .then((member) => {
                                            if (member.errors !== null && member.errors !== "") alert(member.errors)
                                            sessionStorage.setItem("member", JSON.stringify(member.message));
                                            window.location.href = "/member-form";
                                        })
                                })
                        }
                    })
            })
            .catch((error) => {
                console.log("Response error: " + error);
            })
    }



    const handleSubmit = () => {
        setSaving(true);
        setSavingMessage(null);

        const formData = appendData();
        const requestOptions = {
            method: 'POST',
            body: formData
        }
        fetch('api/registration/submitMember', requestOptions)
            .then((response) => {
                response.json()
                    .then((text) => {
                        if (text.errors !== null && text.errors !== "") alert(text.errors)
                        if (user.userID === member.email) {
                            user.regComplete = true;
                            sessionStorage.setItem("user", JSON.stringify(user));
                        }
                        setSaving(false);
                        setSavingMessage(text.message);
                        if (!text.message.includes("Error") && !text.message.includes("Issue")) window.location.href = "/registration-dashboard"
                    })
            })
            .catch((error) => {
                console.log("Response error: " + error);
            })
    }

    return (
        <>
            {!loading ?
                <Container style={{ padding: "15px" }}>
                    <Row>
                        <Col>
                            <div className="d-flex justify-content-end">
                                <HHIEButton
                                    id="return-to-dash"
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => {
                                        window.location.href = "/registration-dashboard"
                                    }}
                                    title="Return to Dashboard"
                                />
                            </div>
                        </Col>
                    </Row>
                    <br />
                    <h2 style={{ textAlign: "center" }}>Member Form</h2>
                    <NameSection member={member} checkOkay={() => { checkBasics() }} />
                    <Row style={{ padding: "4px" }}>
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip id="legal-name-tip">Please select either provider or staff</Tooltip>}
                        >
                            <Col className="justify-content-start" sm={2} style={{ padding: "4px" }}>
                                <div className="justify-content-start">
                                    <FormCheck
                                        label="Provider"
                                        name="staff-type"
                                        type="checkbox"
                                        id="type-provider-radio"
                                        checked={provider && !staff}
                                        onChange={(e) => { setProvider(e.target.checked); if (e.target.checked) setStaff(false) }}
                                    />
                                </div>
                                <div className="justify-content-start">
                                    <FormCheck
                                        label="Staff Member"
                                        name="staff-type"
                                        type="checkbox"
                                        id="type-staff-radio"
                                        checked={!provider && staff}
                                        onChange={(e) => { setStaff(e.target.checked); if (e.target.checked) setProvider(false) }}
                                    />
                                </div>
                            </Col>
                        </OverlayTrigger>
                    </Row>
                    <Row style={{ padding: "4px" }}>
                        <Col className="justify-content-start" sm={2} style={{ padding: "6px" }}>
                            {account.ignorePOCLimit || ((pocLength > 1 || !poc || !member.isPOC) && (pocLength < pocMaxLength || poc || member.isPOC)) ?
                                <OverlayTrigger
                                    placement="bottom"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={<Tooltip id="legal-name-tip">
                                        The POC (Point of Contact) is the person designated by the
                                        Participating Organization to speak on their behalf related
                                        to user accounts in the Health eNet (aka Community Health
                                        Record). The POC is the primary contact for HHIE and may
                                        select user features and authorize change.
                                    </Tooltip>}
                                >
                                    <div>
                                        <FormCheck
                                            label="Point of Contact"
                                            name="staff-type"
                                            type="checkbox"
                                            id="type-poc-radio"
                                            defaultChecked={poc}
                                            onChange={(e) => {
                                                setPoc(e.target.checked);
                                                let modified = member;
                                                modified.isPOC = true; setMember(modified);
                                            }}
                                        />
                                    </div>
                                </OverlayTrigger>
                                :
                                <OverlayTrigger
                                    placement="bottom"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={<Tooltip id="legal-name-tip">
                                        {pocLength <= 1 && "The HHIE requires a minimum of 1 POC per account.\n"}
                                        {pocLength >= pocMaxLength && "The HHIE recommends a maximum of 3 POCs per service (CHR Suite and Notify). To add more POCs, please contact the HHIE.\n"}
                                    </Tooltip>}
                                >
                                    <div>
                                        <FormCheck
                                            disabled
                                            label="Point of Contact"
                                            name="staff-type"
                                            type="checkbox"
                                            id="type-poc-radio"
                                            defaultChecked={poc}
                                        />
                                    </div>
                                </OverlayTrigger>

                            }
                        </Col>
                    </Row>
                    <Row>
                        {provider ?
                            <ProviderSection
                                member={member}
                                specialtiesList={specialtiesList}
                                setProviderOkay={() => { setProviderOkay(true) }}
                                setProviderNotOkay={() => { setProviderOkay(false) }}
                                isProvider={provider}
                            />
                            : <></>
                        }
                        {staff ?
                            <StaffSection
                                member={member}
                                setStaffOkay={() => { setStaffOkay(true) }}
                                setStaffNotOkay={() => { setStaffOkay(false) }}
                                isStaff={staff}
                            />
                            : <></>
                        }
                    </Row>
                    <Row style={{ padding: "4px" }}>
                        <Col></Col>
                        {poc ?
                            <POCSection
                                member={member}
                                setPocOkay={() => { setPocOkay(true) }}
                                setPocNotOkay={() => { setPocOkay(false) }}
                                isPOC={poc}
                                chrAllowed={chrAllowed}
                                notifyAllowed={notifyAllowed}
                                setServicePOC={(service) => { setServicePOC(service) }}
                                account={account}
                            />
                            : <></>}
                    </Row>
                    <DobEmailSection member={member} user={user} checkOkay={() => { checkBasics() }} />
                    <ServicesSection
                        member={member}
                        account={account}
                        user={user}
                        chr={chr}
                        setChr={(value) => { setChr(value) }}
                        dsm={dsm}
                        setDsm={(value) => { setDsm(value) }}
                        referrals={referrals}
                        setReferrals={(value) => { setReferrals(value) }}
                        notify={notify}
                        setNotify={(value) => { setNotify(value) }}
                        provider={provider}
                    />
                    {!saving && savingMessage &&
                        <Row>
                            <Col className="d-flex justify-content-center">
                                <Alert id="saved-message" variant={savingMessage.includes("Success") ? "success" : "danger"}>{savingMessage}</Alert>
                            </Col>
                        </Row>
                    }
                    <SaveSubmitButtons
                        saving={saving}
                        save={(saveContinueNew) => { handleSave(saveContinueNew) }}
                        submit={() => { handleSubmit() }}
                        submitButtonExists={submitFeature}
                        saveAndNewAllowed={true}
                        disabled={(provider && !providerOkay) || (staff && !staffOkay) || (poc && !pocOkay) || !basicReqsOkay}
                    />
                </Container>
                : <></>
            }
        </>
    );
}